<template>
  <div :class="`clienteCliente ${css}`" v-if="visivel">
    <label>Cliente do cliente</label>
    <select class="input" v-model="selecionado" @change="escolher">
      <option :value="null">Selecione</option>
      <option v-for="c of opcoes" :key="'cc' + c.id" :value="c.id">
        {{ c.nome }}{{ c.status === "inativo" ? " (inativo)" : "" }}
      </option>
    </select>
    <small v-if="atualInativo" class="aviso">
      O vínculo atual está inativo. Ao salvar com outra opção ou com "Selecione", ele é substituído.
    </small>
  </div>
</template>

<script>
import { mapActions } from "vuex";

// Seleção de cliente do cliente para o vínculo do job (sc-9885), nos dois modos de
// categorização. Carrega a lista do cliente uma vez, em estado local e não no store, para a
// recategorização de um job não herdar a lista do job anterior. Mostra-se só quando há ao menos
// um ativo, ou quando o vínculo atual do job está inativo, caso em que o atual entra como opção
// marcada para o vínculo não cair em silêncio. Emite `value` com o id escolhido, ou null.
export default {
  name: "ClienteCliente",
  props: {
    cliente: { type: Number, required: true }, // id do cliente dono da lista
    atual: { type: Number, default: null }, // id_cliente_cliente já gravado no job, se houver
    css: { type: String, default: "" },
  },
  data() {
    return { lista: [], selecionado: this.atual, carregado: false };
  },
  computed: {
    ativos() {
      return this.lista.filter(c => c.status === "ativo");
    },
    registroAtual() {
      return this.lista.find(c => c.id === this.atual) || null;
    },
    atualInativo() {
      return !!this.registroAtual && this.registroAtual.status === "inativo";
    },
    opcoes() {
      return this.atualInativo ? [...this.ativos, this.registroAtual] : this.ativos;
    },
    visivel() {
      return this.carregado && (this.ativos.length > 0 || this.atualInativo);
    },
  },
  watch: {
    atual(novo) {
      this.selecionado = novo;
    },
    cliente() {
      this.carregar();
    },
  },
  methods: {
    ...mapActions("admin", ["CLIENTE_CLIENTE_LISTA"]),
    async carregar() {
      this.carregado = false;
      const r = await this.CLIENTE_CLIENTE_LISTA({ id_cliente: this.cliente });
      // 404 é lista vazia no backend; qualquer outro erro já foi avisado pela ação.
      this.lista = r && r.status === 200 && Array.isArray(r.data) ? r.data : [];
      this.carregado = true;
    },
    escolher() {
      // O contrato é id ou null: o payload da categorização exige a chave, e undefined sumiria no JSON.
      this.$emit("value", this.selecionado === undefined ? null : this.selecionado);
    },
  },
  beforeMount() {
    this.carregar();
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.clienteCliente
  .aviso
    display: block
    margin-top: 4px
    opacity: .8
</style>
